import React, {
    HTMLAttributes,
    ReactElement, ReactNode, useContext,
} from "react";
import { SortableItemStateContext } from "./SortableItem";

export interface SortableItemListenerProps extends HTMLAttributes<HTMLDivElement> {
    children?: ReactNode
}

const SortableItemListener = React.forwardRef((
    args: SortableItemListenerProps,
    ref: React.ForwardedRef<HTMLDivElement>,
): ReactElement => {
    const {
        children,
        ...rest
    } = args;
    const context = useContext(SortableItemStateContext);

    const mergedRef = (element: HTMLDivElement | null) => {
        context.setActivatorNodeRef?.(element);
        if (typeof ref === "function") {
            ref(element);
        } else if (ref) {
            // eslint-disable-next-line no-param-reassign
            ref.current = element;
        }
    };

    return (
        <div
            ref={mergedRef}
            {...rest}
            {...context.listeners}
            {...context.attributes}
        >
            {children}
        </div>
    );
});

SortableItemListener.defaultProps = {
};

export default SortableItemListener;
